// extracted by mini-css-extract-plugin
export default {"seoWrap":"styles_seoWrap__u27Oy","seoContent":"styles_seoContent__nJG2h","seoTitle":"styles_seoTitle__1V9zK","seoShadow":"styles_seoShadow__dkUkm","seoBtn":"styles_seoBtn__b5fqv"};